export default "__VITE_ASSET__9dd01440__"